import React from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Input, Form, TextArea, Button, Checkbox } from 'semantic-ui-react';
import TextField from '@material-ui/core/TextField';
import ReadCookie from '../../../functions/readcookies';

const styles = { appBar: { position: 'relative', }, flex: { flex: 1, }, };

function Transition(props) { return <Slide direction="up" {...props} />; }

class FullScreenDialog extends React.Component {

  state = {
    orderDetails: [],
  }

  getOrderData() {
    let context = this;
    context.setState({ load: true, message: 'Getting Invoice' })
    $.ajax({
        type: 'POST', data: { 'id': this.props.data.id },
        url: Server() + 'invoice/getOrderDetails.php',
        success: function(data) {
            console.log(data);
            console.log('data');
            try {
                data = JSON.parse(data);
                data.map((c) => { c.checked = false; c.dqty = c.qty; c.ddisc = c.disc; c.ddiscper = c.discper; })
                context.setState({ originalOrder: data, orderDetails: data, load: false, openCreditNoteDialog: true })
            } catch (error) {
                alert('Error!!!')
                context.setState({ load: false })
            }
        },
        error: function(e) {
            alert('Try again!!')
            context.setState({ load: false });
        }
    });
  }


  onChangeTextBox = (type) => (e, {value}) => { 
    this.setState({ [type]: value }) 
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0 ;
    }
    return value;
  }

  makeIntoDecimalPoint(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }


  onChangeTextBox1 = (type, id) => (e, {value}) => { 
    let orderDetails = this.state.orderDetails;
    orderDetails.map((c) => {

      let quantity = this.convertIntoNumber(c.dqty);
      let uprice = this.convertIntoNumber(c.uprice);
      let tax = this.convertIntoNumber(c.tax);

      if (c.id == id) {
        if (type == 'qty') { c.dqty = value; }
        if (type == 'discper') { 
          c.ddisc = ((((uprice * quantity) + (((uprice * quantity) * tax)/100)) * value)/100);
          c.ddiscper = value;     
        }
        if (type == 'disc') { 
          uprice = uprice + ((uprice * tax)/100);
          let totalPrice = uprice * quantity;
          let discountPrice = totalPrice - (totalPrice - value);
          let discount = discountPrice/totalPrice * 100;
          c.ddiscper = discount;
          c.ddisc = value; 
        }
      }
    })
    this.setState({ orderDetails }) 
  }

  convertLowerToUpper(value) {
    try {
      value = value.toUpperCase()
    } catch (error) {
      
    }
    return value;
  }

  checkCondition() {
    let orderDetails = this.state.orderDetails;
    let itemsToReturn = [];
    orderDetails.map((c) => {
      if (c.checked) {
        itemsToReturn.push(c);
      }
    })
    let checkCondition = 0;

    itemsToReturn.map((x) => {
      let totprice1 = this.convertIntoNumber(x.totprice);
      let qty1 = this.convertIntoNumber(x.qty);
      let oqty = this.convertIntoNumber(x.oqty);
      let discper1 = this.convertIntoNumber(x.discper);
      let qty2 = this.convertIntoNumber(x.dqty);
      let discper2 = this.convertIntoNumber(x.ddiscper);
      discper1 = Math.round(discper1);
      discper2 = Math.round(discper2);
      if (qty1 < qty2) {
        checkCondition = 1;
      }
      if (discper1 > discper2) {
        checkCondition = 2;
      }
      let dnp = this.convertIntoNumber(x.uprice);
      let tax = this.convertIntoNumber(x.tax);
      let Mrp = (dnp + ((dnp * tax)/100));
      let DiscountForSingleProduct = Mrp - ((Mrp * discper2)/100);
      let totprice2 = DiscountForSingleProduct * qty2;
      totprice1 = totprice1/oqty;
      totprice1 = totprice1 * qty2;
      x.totprice1 = totprice1;
    })

    let returnItems = [];

    itemsToReturn.map((c) => {
      returnItems.push({ 
          partno: c.partno, disrs: c.ddisc, disper: c.ddiscper, qty: c.dqty, totprice: c.totprice1, 
          tax: c.tax, orderid: c.id, uprice: c.uprice, brand_id: c.brand_id,  tax: c.tax
      })
    })

    if (checkCondition == 1) {
      alert('You Are Entry More then Purchase Qty!!!')
      return;
    }
    if (checkCondition == 2) {
      alert('You Are Entry Less then Purchase Discount Percentage!!!')
      return;
    }
    this.submit(returnItems);
  }

  handleChange = id => event => {
    let orderDetails = this.state.orderDetails;
    orderDetails.map((c) => {
      if (c.id == id) {
        if (c.checked) {
          c.checked = false;
        }
        else {
          c.checked = true;
        }
      }
    })
    this.setState({ orderDetails })
  };

  submit(items) {
    console.log(items);
    let context = this;
    items = JSON.stringify(items);
    let cook = (ReadCookie("vaigai"));
    let by = cook.id;
    $.ajax({
      type: 'POST', 
      data: { 'id': context.props.data.id, 'items': items, 'cid': context.props.data.cid, 
              'branch_id': context.props.data.branch_id, 'createdBy': by },
      url: Server() + 'invoice/insertreturnitems.php',
      success: function(data) {
        console.log(data);
        try {
          data = JSON.parse(data);
          data.map((c) => {
            
            if (c.status == 'Success') {
              context.setState({ openCreditNoteDialog: false })
              let open = Server() + "pdf/creditnote/creditnote.php?id="+c.id;
              window.open(open);
            }
            else {
              alert(c.status)
            }
          })
        } catch (error) {
          alert('Train Again!!!');
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
  });
  }

  render() {
    const { classes } = this.props;
    let sino = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <center style={{color: 'blue'}} onClick={this.getOrderData.bind(this)}>View</center>
        <Dialog fullScreen
          open={this.state.openCreditNoteDialog} onClose={ () => { this.setState({ openCreditNoteDialog: false }) }}
          TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={ () => { this.setState({ openCreditNoteDialog: false }) }} aria-label="Close"> <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>{this.props.data.invoice_voucher+'  ('+this.props.data.cname+')'}</Typography>
            </Toolbar>
          </AppBar>
          <div style={{margin: '2px', width: '100%'}}>
            <div style={{margin: '5px'}}>
              Search<br/>
              <Input style={{width: '300px'}} onChange={this.onChangeTextBox('search')} value={this.state.search} />
            </div>
            <tabel width="100%" id='table'>
              <tr id='tablehead'>
                <th style={{width: '6%'}}>Sino</th>
                <th style={{width: '6%'}}>Select</th>
                <th style={{width: '10%'}}>PartNO</th>
                <th style={{width: '14%'}}>SpareName</th>
                <th style={{width: '6%'}}>Qty</th>
                <th style={{width: '6%'}}>Dis%</th>
                <th style={{width: '11%'}}>Dis Rs</th>
                <th style={{width: '11%'}}>Disc. Unit Price</th>
                <th style={{width: '12%'}}>Disc. Price</th>
                <th style={{width: '10%'}}>Tax Price</th>
                <th style={{width: '10%'}}>Taxable Amount</th>
              </tr>
              {
                this.state.orderDetails.map((c) => {
                  let dnp = this.convertIntoNumber(c.uprice);
                  let tax = this.convertIntoNumber(c.tax);
                  let qty = this.convertIntoNumber(c.dqty);
                  let discper = this.convertIntoNumber(c.ddiscper);
                  let Mrp = (dnp + ((dnp * tax)/100));
                  let DiscountForSingleProduct = Mrp - ((Mrp * discper)/100);
                  let totprice = DiscountForSingleProduct * qty;
                  let taxs = ((dnp * 18)/100);
                  if (c.checked) {
                    return (
                      <tr style={{backgroundColor: '#FFA5A5'}}>
                        <td>{sino++}</td>
                        <td><center><Checkbox onChange={this.handleChange(c.id)} checked={c.checked} /></center></td>
                        <td>{c.partno}</td>
                        <td>{c.sparename}</td>
                        <td><Input type="number" minimum={0} min={0} value={c.dqty} onChange={this.onChangeTextBox1('qty', c.id)} /></td>
                        <td><Input type="number" value={c.ddiscper} onChange={this.onChangeTextBox1('discper', c.id)} /></td>
                        <td><Input type="number" value={c.ddisc} onChange={this.onChangeTextBox1('disc', c.id)} /></td>
                        <td>{this.makeIntoDecimalPoint(DiscountForSingleProduct)}</td>
                        <td>{this.makeIntoDecimalPoint((dnp - ((dnp * discper)/100)) * (qty))}</td>
                        <td>{this.makeIntoDecimalPoint((taxs - ((taxs * discper)/100)) * qty)}</td>
                        <td>{this.makeIntoDecimalPoint(totprice)}</td>
                      </tr>
                    )
                  }
                  else {
                    return (
                      <tr>
                        <td>{sino++}</td>
                        <td><center><Checkbox onChange={this.handleChange(c.id)} checked={c.checked} /></center></td>
                        <td>{c.partno}</td>
                        <td>{c.sparename}</td>
                        <td><Input disabled value={c.qty} onChange={this.onChangeTextBox1('qty', c.id)} /></td>
                        <td><Input disabled value={c.discper} onChange={this.onChangeTextBox1('discper', c.id)} /></td>
                        <td><Input disabled value={c.disc} onChange={this.onChangeTextBox1('disc', c.id)} /></td>
                        <td>{this.makeIntoDecimalPoint(DiscountForSingleProduct)}</td>
                        <td>{this.makeIntoDecimalPoint((dnp - ((dnp * discper)/100)) * (qty))}</td>
                        <td>{this.makeIntoDecimalPoint((taxs - ((taxs * discper)/100)) * qty)}</td>
                        <td>{this.makeIntoDecimalPoint(totprice)}</td>
                      </tr>
                    )
                  }
                  
                })
              }
            </tabel>
            <center style={{marginTop: '5px'}}>
              <br/>
              <Form>
                <TextArea style={{width: '400px'}} value={this.state.remarks} onChange={this.onChangeTextBox('remarks')} placeholder='Tell us more' />
              </Form>
              <div style={{marginLeft: '20px'}}>
                <br/>
                <Button onClick={this.checkCondition.bind(this)}>Submit</Button>
              </div>
            </center>
          </div>
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(FullScreenDialog);